import React from 'react';

export const UserContext = React.createContext(null);

export const TenantContext = React.createContext(null);

export const TeammessageContext = React.createContext(null);

export const LanuageContext = React.createContext(null);

export const OpsInfoContext = React.createContext(null);

export const ProductContext = React.createContext(null);

export const ThemeContext = React.createContext(null);

export interface UploadState {
  open: boolean;
  realClose: boolean;
  status: 'end' | 'updating';
  warning: boolean;
  currentDocument: {
    id: string;
    name: string;
    acl?: Record<string, unknown>;
  } | null;
}

export interface UploadContextValue {
  upload: UploadState;
  setUpload: React.Dispatch<React.SetStateAction<UploadState>>;
}

export const UploadContext = React.createContext<UploadContextValue | null>(null);

